import {Button, Stack, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {Controller, useFormContext} from 'react-hook-form';

import {AlertModal, MaskedInput} from 'presentation/components';
import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {DocumentEnum} from 'presentation/pages/private/refund/constants/documentEnum';
import {translations} from 'presentation/translations-new';
import {masks} from 'presentation/utils';
import {DocumentsFieldsProps} from './types';

const {searchByCNPJ, searchByCPF, documentMatchCpfProviderModal} =
	translations['pt-br'].privateFlow.refund.receiptRegistrationPage.providerData;

export const DocumentsFields = ({
	documentName,
	handleReset,
	label,
	customRegister = 'professionalDocument',
	helperText,
	error,
}: DocumentsFieldsProps) => {
	const {watch, resetField, clearErrors} = useFormContext();
	const [isProviderDocumentMatchUserCpfState, setIsProviderDocumentMatchUserCpfState] =
		useState(false);
	const isCpf = documentName === DocumentEnum.CPF;
	const PROVIDER_DOCUMENT_MATCH_USER_CPF = watch('providerDocumentMatchUserCpf');
	const {isEnabled: isAlphanumericCnpjEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_REFUND_ALPHANUMERIC_DOCUMENT,
	);

	useEffect(() => {
		if (PROVIDER_DOCUMENT_MATCH_USER_CPF) {
			setIsProviderDocumentMatchUserCpfState(true);
			return;
		}
		setIsProviderDocumentMatchUserCpfState(false);
	}, [PROVIDER_DOCUMENT_MATCH_USER_CPF]);

	const configByDocument = {
		label: isCpf ? searchByCPF : searchByCNPJ,
		maskOptions: isCpf ? masks.cpf : masks.cnpj({alphaNumeric: isAlphanumericCnpjEnabled}),
	};
	const documentLabel = label || configByDocument.label;

	function handleOnClear() {
		if (handleReset) handleReset();
		resetField(customRegister, {defaultValue: ''});
		clearErrors(customRegister);
	}

	function handleOnFocus() {
		if (handleReset) handleReset();
		clearErrors(customRegister);
	}

	return (
		<Stack gap={1}>
			<Typography color="primary" fontWeight={600}>
				{documentLabel}
			</Typography>

			<Controller
				name={customRegister}
				render={({field}) => (
					<MaskedInput
						{...field}
						onChange={e => {
							field.onChange(e);
							clearErrors(customRegister);
						}}
						handleClearQuery={handleOnClear}
						$fieldName={customRegister}
						onFocus={handleOnFocus}
						isRefundFlow
						maskOptions={configByDocument.maskOptions}
						variant="outlined"
						label={`Digite o ${documentName}`}
						placeholder={`Digite o ${documentName}`}
						error={!!error}
						helperText={helperText}
					/>
				)}
			/>

			<AlertModal
				open={isProviderDocumentMatchUserCpfState}
				onClose={() => setIsProviderDocumentMatchUserCpfState(false)}
				variant="info"
				headerTitle={documentMatchCpfProviderModal.headerTitle}
				title={documentMatchCpfProviderModal.title}
				description={documentMatchCpfProviderModal.description}
				footerContent={
					<Button
						onClick={() => setIsProviderDocumentMatchUserCpfState(false)}
						variant="contained"
						size="large"
						fullWidth>
						{documentMatchCpfProviderModal.primaryActionText}
					</Button>
				}
			/>
		</Stack>
	);
};
